export enum SocialTypes {
  INSTAGRAM = "instagram",
  LINKEDIN = "linkedin",
  TWITTER = "twitter",
  FACEBOOK = "facebook",
  TIKTOK = "tiktok",
  YOUTUBE = "youtube",
}
